import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/index/index'
import Apply from '@/views/apply/index'
import ApplySecondDetail from '@/views/apply/detail'
import ApplyDetail from '@/views/apply/applyDetail'
import Introduce from '@/views/about/introduce'
import xsydls from '@/views/fwzc/xsydls'
import onlineClass from '@/views/fwzc/onlineClass'
import tecArticles from '@/views/fwzc/tecArticles'
import news from '@/views/news/index'
import newsDetail from '@/views/news/detail'
import product from '@/views/center/index'
import productDetail from '@/views/center/productDetail'
import productVideo from '@/views/center/compontents/productVideo'
import joinUs from '@/views/about/joinUs'
import recruit from '@/views/recruit/index'
import about from '@/views/about/index'
import zlgl from '@/views/zlykkx/index'
import demo from '@/views/demo/index'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      component: Home,
    },
    {
      path: '/demo',
      name: 'demo',
      component: demo,
    },
    {
      path: '/apply',
      name: '行业应用',
      component: Apply,
    },{
      path: '/apply/detail',
      name: '行业应用',
      component: ApplySecondDetail,
    }, {
      path: '/introduce',
      name: '联系我们',
      component: Introduce,
    },{
      path: '/apply/ApplyDetail',
      name: '行业应用',
      component: ApplyDetail,
    },{
      path: '/zlykkx/zlgl',
      name: '质量管理',
      component: zlgl,
    },{
      path: '/fwzc/xsydls',
      name: '销售与代理商',
      component: xsydls,
    },{
      path: '/fwzc/onlineClass',
      name: '在线课堂',
      component: onlineClass,
    },{
      path: '/fwzc/tecArticles',
      name: '技术文章',
      component: tecArticles,
    },{
      path: '/news',
      name: '新闻资讯',
      component: news,
    },{
      path: '/newsDetail',
      name: '新闻资讯',
      component: newsDetail,
    },{
      path: '/product/index',
      name: '产品中心',
      component: product,
    },{
      path: '/product/productDetail',
      name: '产品详情',
      component: productDetail,
    },{
      path: '/joinUs',
      name: '产品详情',
      component: joinUs,
    },{
      path: '/recruit',
      name: '招聘',
      component: recruit,
    },{
      path: '/about',
      name: '招聘',
      component: about,
    },{
      path: '/productVideo',
      name: '产品视频',
      component: productVideo,
    },
    {
      path: '*', // 页面不存在的情况下会跳到404页面
      redirect: '/',
      name: 'notFound',
      hidden: true
    }
  
  ],
  mode: 'history',
})



// WEBPACK FOOTER //
// ./src/router/index.js